import Link from 'next/link'
import { Swiper, SwiperSlide } from 'swiper/react'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import { FreeMode } from 'swiper'
import { EmptyGuid } from '@components/utils/constants'
import { useUI } from '@components/ui'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { recordGA4Event } from '@components/services/analytics/ga4'
import { useMoEngageEvent } from 'hooks/useMoengageEvent'
import { MO_ENGAGE_EVENT } from 'hooks/moengage_event.modal'

declare const window: any

interface Props {
  customLinks: any
  handleFilters: any
  clearAll: any
}

export default function FiltersCategory({ customLinks }: Props) {
  const { user } = useUI()
  const trackMoEngageEvent = useMoEngageEvent()

  function filterClick(section: any, sectionId: any) {
    const getHeader = () => {
      if (typeof section === 'object' && section !== null) {
        const startIndex = section.label.indexOf('\\"label\\"') + 13 // +13 to skip over '": "' characters
        const endIndex = section.label.indexOf('\\"', startIndex) // Find the end of the label value
        const labelValue = section.label.slice(startIndex, endIndex)
        return labelValue
      } else {
        return section?.label
      }
    }

    if (typeof window !== 'undefined') {
      recordGA4Event(window, GA_EVENT.FILTER_CLICK, {
        filter_name: section?.label,
        header: getHeader(),
        current_page: window?.location?.href,
        position: sectionId,
        loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
      })
    }

    trackMoEngageEvent(
      MO_ENGAGE_EVENT.FILTER_CLICK,
      {
        filter_name: section?.label,
        filter_value: '',
        current_page: window?.location?.href,
      },
      window
    )
  }

  return (
    <>
      <Swiper
        slidesPerView={'auto'}
        spaceBetween={6}
        navigation={false}
        loop={false}
        freeMode={true}
        modules={[FreeMode]}
        slidesOffsetAfter={6}
        slidesOffsetBefore={16}
        className="sm:border-t-0 mySwiper icon-bg-none category-filter-swiper"
      >
        {customLinks?.map((section: any, sectionId: number) => {
          let label = null
          let imgUrl = null
          let isJsonItem = false
          try {
            const labelInfoTemp = JSON?.parse(section?.label)
            const labelInfo = JSON?.parse(labelInfoTemp)
            label = labelInfo?.label
            imgUrl = labelInfo?.thumbnail
            isJsonItem = true
          } catch {
            label = section?.label
          }

          return (
            <SwiperSlide
              className={`px-0 w-auto`}
              key={sectionId}
              style={{ width: 'auto' }}
            >
              <Link legacyBehavior href={`${section?.link}`} passHref>
                <a
                  href={`/${section?.link}`}
                  className={`flex rounded-lg ${!isJsonItem ? 'py-1.5' : ''}`}
                  style={{
                    border: '1px solid #E9E5DF',
                  }}
                  onClick={() => filterClick(section, sectionId)}
                >
                  <span
                    className={`flex items-center mx-auto ${
                      !isJsonItem ? ' justify-center' : ''
                    }`}
                  >
                    <span
                      className={`flex items-center mx-auto ${
                        !isJsonItem ? ' justify-center' : ''
                      }`}
                    >
                      <span
                        className={`flex items-center relative leading-none truncate text-xs text-primary text-ellipsis py-1.5 ${
                          !isJsonItem
                            ? 'py-1.5 justify-center text-center px-4'
                            : 'ml-1 text-left pr-4'
                        }`}
                      >
                        {imgUrl && (
                          <img
                            placeholder="blur"
                            className="mr-1"
                            src={imgUrl}
                            alt={label}
                            style={{
                              width: 'auto',
                              maxWidth: '26px',
                              height: '26px',
                            }}
                          />
                        )}
                        <span>{label}</span>
                      </span>
                    </span>
                  </span>
                </a>
              </Link>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </>
  )
}
